import { useEffect, type Dispatch, type SetStateAction } from 'react'
import { useQueryClient } from 'react-query'

import { fetchAssetAnalysts, useAssetAnalystsQuery } from '../../../../../../services/hooks/assetAnalysts/queries/useAssetAnalystsQuery'
import { type Column, Table } from '../../../../../../components/Table'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'

type Props = {
  filters: FiltersDomain
  columns: Column[]
  setFilters: Dispatch<SetStateAction<FiltersDomain>>
}

export const TableWithManuallyPagination = ({
  filters,
  columns,
  setFilters,
}: Props) => {
  const queryClient = useQueryClient()
  const { data, refetch } = useAssetAnalystsQuery(filters)

  const handlePageChange = (pageNumber: number) =>
    setFilters((prevState) => ({
      ...prevState,
      page: pageNumber,
    }))

  const handleChangingRegistersPerPage = (registersPerPage: number) => {
    setFilters((prevState) => ({
      ...prevState,
      page: 1,
      take: registersPerPage,
    }))
  }

  useEffect(() => {
    if (data?.meta?.hasNextPage) {
      queryClient.prefetchQuery(['asset-analysts', filters], () => {
        return fetchAssetAnalysts(filters)
      })
    }
  }, [data, filters, queryClient])

  useEffect(() => {
    refetch()
  }, [])

  const formattedRows = data?.data?.map((assetAnalyst) => ({
    id: assetAnalyst.id,
    fullName: assetAnalyst.fullName,
    asset: assetAnalyst.asset?.fullName,
  }))

  return (
    <Table
      columns={columns}
      rows={formattedRows || []}
      currentPage={filters.page}
      registersPerPage={filters.take}
      totalCountOfRegisters={data?.meta?.itemCount}
      onPageChange={handlePageChange}
      noContentMessage="Sem registro de analista(s)"
      onChangingRegistersPerPage={handleChangingRegistersPerPage}
    />
  )
}
